// extracted by mini-css-extract-plugin
module.exports = {"top":"styles_top__10IQy","form":"styles_form__3xZlA"};